export default "<p>crecimiento works!</p>\n"